import { render, staticRenderFns } from "./setupInfluencer.vue?vue&type=template&id=fbd76fe8&"
import script from "./setupInfluencer.vue?vue&type=script&lang=js&"
export * from "./setupInfluencer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports